export default __webpack_public_path__ + "static/media/mon_nails.9addd214.jpeg";